import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import SubHeader from 'root/src/client/web/typography/SubHeader'
import { colorsNew, doveGray, ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import { creatorAcceptedKey } from 'root/src/shared/constants/keys'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import goToViewCreatorDataHandler from 'root/src/client/logic/creatorData/handlers/goToViewCreatorDataHandler'
import assigneeRouteSelector from 'root/src/client/logic/project/util/assigneeRouteSelector'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'

const styles = {
	root: {
		backgroundColor: colorsNew.dark2,
		width: 160,
		height: 196,
		minWidth: 160,
		minHeight: 196,
		margin: [[0, 30, 0, 0]],
		borderRadius: 8,
		overflow: 'hidden',
		cursor: 'pointer',
		position: 'relative',
		boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1)',
		[ltGtMediaQuery]: {
			width: 149,
			height: 180,
			minWidth: 149,
			minHeight: 190,
			margin: [[0, 16, 0, 0]],
		},
	},
	imageContainer: {
		maxHeight: 142,
	},
	image: {
		width: '100%',
		maxHeight: 142,
		[ltGtMediaQuery]: {
			maxHeight: 130,
		},
	},
	assigneeTextContainer: {
		padding: 12,
		backgroundColor: colorsNew.dark2,
	},
	fontStyle: {
		margin: [[6, 12]],
		fontSize: 14,
		fontWeight: 400,
	},
	marksContainer: {
		position: 'absolute',
		width: '100%',
		display: 'flex',
	},
	mark: {
		fontSize: 10,
		color: 'white',
		textAlign: 'center',
		padding: [[4, 6]],
		borderRadius: 2,
		margin: 12,
	},
	acceptedMark: {
		backgroundColor: '#08ad66',
	},
	gray: {
		color: doveGray,
	},
}

const Assignee = memo(({
	displayName, image, mnemonicId, classes, accepted, followerCount, platform,
}) => (
	<div
		className={classNames(classes.root, 'layout-column layout-align-stretch')}
		onClick={() => goToViewCreatorDataHandler(
			assigneeRouteSelector({ mnemonicId, displayName, platform }),
		)}
	>
		<div className={classNames(classes.imageContainer)}>
			{accepted === creatorAcceptedKey
				&& (
					<div className={classes.marksContainer}>
						<div className={classNames(classes.mark, classes.acceptedMark)}>
							Accepted
						</div>
					</div>
				)
			}
			<LazyLoadImage
				src={addHttpsProtocol(image)}
				alt={mnemonicId}
				className={classes.image}
			/>
		</div>
		<div className={classNames('', classes.linkText)}>
			<SubHeader
				className={classes.fontStyle}
			>
				{displayName}
			</SubHeader>
			{followerCount >= 0 && (
				<SubHeader
					className={classNames(classes.fontStyle, classes.gray)}
				>
					{`${followerCount} followers`}
				</SubHeader>
			)}
		</div>
	</div>
))

export default withStyles(styles, { name: 'MuiAssignee' })(Assignee)
